// @license Copyright (c) 2016 Copyright Holder All Rights Reserved.
(function () {
	"use strict";

	/*
	Info Button Directive
	*/

	angular.module("swurveys.maker")
		.directive("infoButton", Handler)

	function Handler() {
		return {
			restrict: 'E',
			replace: true,
            transclude: true,
            scope: true,
			templateUrl: 'app/maker/states/editor/components/info/info.html',

		}
	}

}());

